import { jwtDecode } from "jwt-decode";
import getSitesData from "./getSitesApi";

const cmsVersionMapDestinations = {
  1: "base.curaytor.com",
  2: "content.curaytor.com"
};

const isUrlCrm = redirectUrl => {
  if (typeof redirectUrl !== "string") {
    return false;
  }

  const keys = Object.keys(cmsVersionMapDestinations);

  for (let i = 0; i < keys.length; i++) {
    const target = cmsVersionMapDestinations[keys[i]];

    if (redirectUrl.startsWith(`https://${target}`)) {
      return true;
    }
  }

  return false;
};

// Redirect v1 users to base.curaytor.com and v2 users to content.curaytor.com
export const convertRedirectUrl = async (token, originalRedirectUrl) => {
  const isRedirectingToCRM = isUrlCrm(originalRedirectUrl);

  if (!isRedirectingToCRM) {
    return originalRedirectUrl;
  }

  const parsedRedirect = new URL(originalRedirectUrl);

  const decodedToken = jwtDecode(token);
  const sitesData = await getSitesData({ domain: decodedToken.domain });
  const cmsVersion = sitesData.data.settings.cms_version || 1;

  const targetHost = cmsVersionMapDestinations[cmsVersion];

  parsedRedirect.host = targetHost;
  parsedRedirect.searchParams.set("redirect_url", `https://${targetHost}/`);

  return parsedRedirect.toString();
};



// WEBPACK FOOTER //
// ./src/services/SitesApi/convertRedirectUrl.js